exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".main--center--32M2obaZ {\r\n  text-align: center;\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n.main--sm--1-8uzdH- {\r\n  height: 64px;\r\n  width:64px;\r\n}\r\n.main--med--36ufcwGN {\r\n  height: 128px;\r\n  width: 128px;\r\n}\r\n.main--lg--_-osuipz {\r\n  height: 256px;\r\n  width:256px;\r\n}", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/components/widgets/busy/main.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iCAAiC;CAClC;AACD;EACE,aAAa;EACb,WAAW;CACZ;AACD;EACE,cAAc;EACd,aAAa;CACd;AACD;EACE,cAAc;EACd,YAAY;CACb","file":"main.css","sourcesContent":[".center {\r\n  text-align: center;\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n.sm {\r\n  height: 64px;\r\n  width:64px;\r\n}\r\n.med {\r\n  height: 128px;\r\n  width: 128px;\r\n}\r\n.lg {\r\n  height: 256px;\r\n  width:256px;\r\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"center": "main--center--32M2obaZ",
	"sm": "main--sm--1-8uzdH-",
	"med": "main--med--36ufcwGN",
	"lg": "main--lg--_-osuipz"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/widgets/busy/main.css
// module id = 429
// module chunks = 0